import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom"; // Use useNavigate for back button functionality
import { getAllOrdersOfUser } from "../../redux/actions/order";
import { FaShippingFast, FaCheckCircle, FaUndo } from 'react-icons/fa';
import socket from '../../socket/socket';
import { toast } from "react-toastify";

const TrackOrder = () => {
  const { orders } = useSelector((state) => state.order);
  const { user } = useSelector((state) => state.deliveryUser);
  const [currentOrderStatus, setCurrOrderStatus] = useState(null); // Correctly declared state
  const dispatch = useDispatch();

  const { id } = useParams();
  const navigate = useNavigate(); // For back navigation

  useEffect(() => {
    // Fetch all orders for the user
    dispatch(getAllOrdersOfUser(user._id));
  }, [dispatch, user._id]);

  const data = orders && orders.find((item) => item._id === id);

  useEffect(() => {
    if (data) {
      // console.log(`Joining socket room order_${data._id}`);
      socket.emit('orderJoin', `order_${data._id}`); // sending connection to backend

      // Set initial status
      setCurrOrderStatus(data.status);

      // Listen for order updates
      const handleOrderUpdate = (dataFromServer) => {
        // console.log("Order updated data from server:", dataFromServer);

        // Update the local status
        setCurrOrderStatus(dataFromServer.status);

        toast.success(`Order status updated: ${dataFromServer.status}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

      };
      // handleOrderUpdate function is call back here
      socket.on('orderUpdated', handleOrderUpdate);  // Receiving connection mssg from backend

      // Cleanup listener when component unmounts or order changes
      return () => {
        // console.log(`Leaving socket room order_${data._id}`);
        socket.off('orderUpdated', handleOrderUpdate); // Remove listener
        socket.emit('orderLeave', `order_${data._id}`); // Optional: Leave the room if implemented on server
      };
    }
  }, [data]); // Re-run when `data` changes

  const statuses = [
    "Processing",
    "Accepted",
    "Transferred to delivery partner",
    "Shipping",
    "Received",
    "On the way",
    "Delivered",
    // "Processing refund",
    // "Refund Success",
  ];

  const getStatusMessage = (status) => {
    switch (status) {
      case "Processing":
        return "Your Order is being processed in the shop.";
      case "Accepted":
        return "Your Order is accepted by the seller.";
      case "Transferred to delivery partner":
        return "Your Order has been handed over to the delivery partner.";
      case "Shipping":
        return "Your Order is on its way with our delivery partner.";
      case "Received":
        return "Your Order has arrived in your city and is ready for delivery.";
      case "On the way":
        return "Our Delivery partner is on the way to deliver your order.";
      case "Delivered":
        return "Your order has been delivered!";
      case "Processing refund":
        return "Your refund is being processed.";
      case "Refund Success":
        return "Your refund was successful!";
      default:
        return "We are currently processing your order.";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Processing":
      case "Accepted":
        return <FaShippingFast className="text-blue-500 text-2xl" />;
      case "Transferred to delivery partner":
      case "Shipping":
      case "Received":
      case "On the way":
        return <FaShippingFast className="text-yellow-500 text-2xl" />;
      case "Delivered":
        return <FaCheckCircle className="text-green-500 text-2xl" />;
      case "Processing refund":
      case "Refund Success":
        return <FaUndo className="text-red-500 text-2xl" />;
      default:
        return <FaShippingFast className="text-gray-500 text-2xl" />;
    }
  };

  const handleBackClick = () => {
    navigate("/profile"); // Navigate back to the profile page
  };

  return (
    <div className="w-full h-screen flex flex-col px-4 py-6 overflow-auto bg-gray-100">
      {/* Fixed Back Button */}
      <div className="w-full flex justify-start mb-4">
        <button
          onClick={handleBackClick}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Back
        </button>
      </div>

      {/* Order Tracking Content */}
      <div className="max-w-lg w-full bg-white p-6 rounded-lg shadow-lg mx-auto">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center text-gray-800">Track Your Order</h2>
        </div>
        {data ? (
          <div>
            <div className="mb-4">
              <h3 className="text-xl font-semibold text-gray-800">{getStatusMessage(currentOrderStatus)}</h3>
            </div>

            <div className="space-y-4">
              {statuses.map((status) => (
                <div
                  key={status}
                  className={`flex items-center space-x-3 p-2 rounded-lg ${
                    currentOrderStatus === status
                      ? "bg-blue-100 border-l-4 border-blue-500"
                      : "bg-gray-50"
                  }`}
                >
                  {getStatusIcon(status)}
                  <span
                    className={`text-lg ${
                      currentOrderStatus === status
                        ? "text-blue-600 font-semibold"
                        : "text-gray-600"
                    }`}
                  >
                    {status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <h1 className="text-xl font-semibold text-gray-600">Order not found</h1>
        )}
      </div>
    </div>
  );
};

export default TrackOrder;
